export default "__VITE_ASSET__3edd4f73__"